export default __webpack_public_path__ + "static/media/footerLogo.175068a3.png";